import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
import { ref, onMounted, computed, onUnmounted } from '../../adapter-vue';
import { TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal, outsideClick } from '@tencentcloud/universal-api';
import SearchInput from './search-input/index.vue';
import SearchContainer from './search-container/index.vue';
import SearchResult from './search-result/index.vue';
import SearchMore from './search-more/index.vue';
import { searchMessageTypeDefault } from './search-type-list';
import { searchMessageTimeDefault } from './search-time-list';
import { isPC, isUniFrameWork } from '../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    searchType: {
      default: () => {
        return isUniFrameWork ? 'conversation' : 'global';
      }
    }
  },
  setup(__props) {
    var props = __props;
    var globalSearchRef = ref();
    // 当前会话
    var currentConversationID = ref('');
    // 控制搜索状态
    var searchingStatus = ref(false);
    // 是否展示指定会话内搜索: 与 TUIChat 交互，由 TUIChat MessageInputToolBar 中 "查看历史消息ICON" 控制
    var isShowInConversationSearch = ref(isUniFrameWork);
    // 是否全屏搜索 - 移动端正在搜索时全屏搜索
    var isFullScreen = computed(() => !isPC && (props.searchType === 'global' && searchingStatus.value || props.searchType === 'conversation' && isShowInConversationSearch.value));
    var initSearchValue = searchType => {
      TUIStore.update(StoreName.SEARCH, 'currentSearchInputValue', {
        value: '',
        searchType: searchType
      });
      TUIStore.update(StoreName.SEARCH, 'currentSearchMessageType', {
        value: searchMessageTypeDefault[searchType],
        searchType: searchType
      });
      TUIStore.update(StoreName.SEARCH, 'currentSearchMessageTime', {
        value: searchMessageTimeDefault,
        searchType: searchType
      });
    };
    function onCurrentConversationIDUpdate(conversationID) {
      if (!isUniFrameWork && currentConversationID.value !== conversationID) {
        // pc端 单页面 切换会话，关闭搜索
        closeInConversationSearch();
      }
      currentConversationID.value = conversationID;
    }
    function onCurrentSearchingStatusChange(value) {
      if ((value === null || value === void 0 ? void 0 : value.searchType) === props.searchType) {
        searchingStatus.value = value === null || value === void 0 ? void 0 : value.isSearching;
        // global search ui bind on click outside close
        if ((value === null || value === void 0 ? void 0 : value.searchType) === 'global' && globalSearchRef.value) {
          if (isPC && value.isSearching) {
            outsideClick.listen({
              domRefs: globalSearchRef.value,
              handler: closeGlobalSearch
            });
          }
        }
        if ((value === null || value === void 0 ? void 0 : value.searchType) === 'global' && isUniFrameWork) {
          var _TUIGlobal$hideTabBar, _TUIGlobal$showTabBar;
          // hide tab bar in uni-app when global searching
          value.isSearching ? TUIGlobal === null || TUIGlobal === void 0 || (_TUIGlobal$hideTabBar = TUIGlobal.hideTabBar()) === null || _TUIGlobal$hideTabBar === void 0 ? void 0 : _TUIGlobal$hideTabBar.catch(() => {}) : TUIGlobal === null || TUIGlobal === void 0 || (_TUIGlobal$showTabBar = TUIGlobal.showTabBar()) === null || _TUIGlobal$showTabBar === void 0 ? void 0 : _TUIGlobal$showTabBar.catch(() => {});
        }
      }
    }
    function onIsShowInConversationSearchChange(value) {
      isShowInConversationSearch.value = !!value;
      isShowInConversationSearch.value && initSearchValue(props.searchType);
    }
    onMounted(() => {
      // init with default value
      ['global', 'conversation'].forEach(type => {
        initSearchValue(type);
      });
      // watch store change
      TUIStore.watch(StoreName.CONV, {
        currentConversationID: onCurrentConversationIDUpdate
      });
      TUIStore.watch(StoreName.SEARCH, {
        currentSearchingStatus: onCurrentSearchingStatusChange,
        isShowInConversationSearch: onIsShowInConversationSearchChange
      });
    });
    onUnmounted(() => {
      // unwatch store change
      TUIStore.unwatch(StoreName.CONV, {
        currentConversationID: onCurrentConversationIDUpdate
      });
      TUIStore.unwatch(StoreName.SEARCH, {
        currentSearchingStatus: onCurrentSearchingStatusChange,
        isShowInConversationSearch: onIsShowInConversationSearchChange
      });
    });
    function closeGlobalSearch() {
      TUIStore.update(StoreName.SEARCH, 'currentSearchingStatus', {
        isSearching: false,
        searchType: props.searchType
      });
    }
    function closeInConversationSearch() {
      TUIStore.update(StoreName.SEARCH, 'isShowInConversationSearch', false);
    }
    return (_ctx, _cache) => {
      return _ctx.searchType === 'global' || (_ctx.searchType === 'conversation' || !_ctx.searchType && _unref(isUniFrameWork)) && _unref(isShowInConversationSearch) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['tui-search', !_unref(isPC) && 'tui-search-h5', "tui-search-main-".concat(_ctx.searchType ? _ctx.searchType : 'conversation'), _unref(isFullScreen) && 'tui-search-h5-full-screen'])
      }, [_ctx.searchType === 'global' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "globalSearchRef",
        ref: globalSearchRef,
        class: _normalizeClass(['tui-search-global', !_unref(isPC) && 'tui-search-h5-global'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(['tui-search-global-header', !_unref(isPC) && 'tui-search-h5-global-header'])
      }, [_createVNode(SearchInput, {
        class: "search-input",
        searchType: _ctx.searchType
      }, null, 8, ["searchType"]), _unref(isPC) || !_unref(searchingStatus) ? (_openBlock(), _createBlock(SearchMore, {
        key: 0,
        class: "search-more",
        searchType: _ctx.searchType
      }, null, 8, ["searchType"])) : _createCommentVNode("", true)], 2), _unref(searchingStatus) ? (_openBlock(), _createBlock(SearchContainer, {
        key: 0,
        class: "search-container",
        popupPosition: "bottom",
        searchType: _ctx.searchType
      }, {
        result: _withCtx(() => [_createVNode(SearchResult, {
          class: "search-result",
          searchType: _ctx.searchType
        }, null, 8, ["searchType"])]),
        _: 1
      }, 8, ["searchType"])) : _createCommentVNode("", true)], 2)) : _ctx.searchType === 'conversation' && _unref(isShowInConversationSearch) || _unref(isUniFrameWork) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(['tui-search-conversation', !_unref(isPC) && 'tui-search-h5-conversation'])
      }, [_createVNode(SearchContainer, {
        class: "search-container",
        popupPosition: "aside",
        searchType: _ctx.searchType ? _ctx.searchType : 'conversation',
        onCloseInConversationSearch: closeInConversationSearch
      }, {
        input: _withCtx(() => [_createVNode(SearchInput, {
          searchType: _ctx.searchType ? _ctx.searchType : 'conversation'
        }, null, 8, ["searchType"])]),
        result: _withCtx(() => [_createVNode(SearchResult, {
          class: "search-result",
          searchType: _ctx.searchType ? _ctx.searchType : 'conversation'
        }, null, 8, ["searchType"])]),
        _: 1
      }, 8, ["searchType"])], 2)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true);
    };
  }
});